import Navbar from "./amotive/NavbarTop";
import CardSell2 from "./amotive/CardSell2";
import CardSell3 from "./amotive/CardSell3";
import AreaChart from "./amotive/AreaChart";
import BarChart from "./amotive/BarChart";
import BarChartArIt from "./amotive/BarChartArIt";
import GraphicDay from "./amotive/GraphicDay";
import GraphicWeek from "./amotive/GraphicWeek";
import TabsClient from "./amotive/TabsClient";
import TabsTipoCli from "./amotive/TabsTipoCli";
import GoogleMap from "./amotive/GoogleMap";
import FooterMobile from "./amotive/FooterMobile";

import React from "react";
import "./amotive/amotive-liquid.css";

function Home() {
  const apikey = "AIzaSyD16h98hJe26HkkEvzKPbH2WytgT5srggM";

  return (
    <div className="main-container am-dashboard-shell">
      <Navbar />

      <main className="amotive am-dashboard-grid">
        {/* RIGA 1 / COLONNA 1:
            INFO ORDINI + DETTAGLI ORDINI insieme */}
        <section className="am-cell am-summary-cell">
          <div className="am-summary-pair">
            <CardSell3 />
            <CardSell2 />
          </div>
        </section>

        {/* RIGA 1 / COLONNA 2 */}
        <section className="am-cell">
          <TabsClient />
        </section>

        {/* RIGA 1 / COLONNA 3 */}
        <section className="am-cell">
          <TabsTipoCli />
        </section>

        {/* RIGA 2 */}
        <section className="am-cell">
          <GraphicDay />
        </section>

        <section className="am-cell">
          <GraphicWeek />
        </section>

        <section className="am-cell">
          <GoogleMap apiKey={apikey} />
        </section>

        {/* RIGA 3 */}
        <section className="am-cell">
          <AreaChart />
        </section>

        <section className="am-cell">
          <BarChart />
        </section>

        <section className="am-cell">
          <BarChartArIt />
        </section>

        {/* Solo mobile, dopo l'ultimo widget */}
        <FooterMobile />
      </main>
    </div>
  );
}

export default Home;
